<template>
  <el-drawer title="连接设置" :visible="visible" direction="rtl" size="420px" custom-class="settings-drawer" @update:visible="$emit('update:visible', $event)">
    <div class="drawer-content">
      <p class="drawer-intro">前端通过 MQTT WebSocket 接收设备状态和 JPEG 视频分片。</p>
      <el-form label-position="top">
        <el-form-item label="设备编号"><el-input v-model.trim="draft.deviceId" placeholder="cam01" /></el-form-item>
        <el-form-item label="MQTT WebSocket 地址"><el-input v-model.trim="draft.mqttUrl" placeholder="wss://wxsky.com:58083" /></el-form-item>
        <div class="form-columns">
          <el-form-item label="MQTT 用户名"><el-input v-model="draft.mqttUsername" /></el-form-item>
          <el-form-item label="MQTT 密码"><el-input v-model="draft.mqttPassword" show-password /></el-form-item>
        </div>
        <el-button class="save-button" type="primary" @click="save">保存并重新连接</el-button>
      </el-form>
      <div class="settings-note"><i class="el-icon-info"></i><span>无需和摄像头处于同一局域网。ESP32 使用 TCP 端口 51883，浏览器使用 WebSocket 端口 58083。</span></div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'ConnectionSettings',
  props: {
    visible: Boolean,
    config: { type: Object, required: true }
  },
  data () {
    return { draft: { ...this.config } }
  },
  watch: {
    config: {
      deep: true,
      handler (value) { this.draft = { ...value } }
    },
    visible (value) {
      if (value) this.draft = { ...this.config }
    }
  },
  methods: {
    save () {
      if (!this.draft.deviceId || !this.draft.mqttUrl || !this.draft.mqttUsername || !this.draft.mqttPassword) {
        this.$message.warning('请完整填写设备编号和 MQTT 连接信息')
        return
      }
      this.$emit('save', { ...this.draft })
    }
  }
}
</script>
